import { render, staticRenderFns } from "./OnlineBookingFeeChargeSummary.vue?vue&type=template&id=b1a5369e"
import script from "./OnlineBookingFeeChargeSummary.vue?vue&type=script&lang=js"
export * from "./OnlineBookingFeeChargeSummary.vue?vue&type=script&lang=js"
import style0 from "./OnlineBookingFeeChargeSummary.vue?vue&type=style&index=0&id=b1a5369e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports